<template>
  <div class="van-image" style="width: 100%; height: 100%;">
    <div id="demoH5"></div>

  </div>
</template>

<script>
import Pdfh5 from "pdfh5";
import {Base64} from "js-base64";
import "pdfh5/css/pdfh5.css";
export default {
  components: {
    Pdfh5,Base64
  },
  data() {
    return {
      pdfSrc: Base64.decode(this.$route.query.pdf) //"https://smart-curtain.oss-cn-hangzhou.aliyuncs.com/quotation-report/70020-9baaf739cac64fb3b56994807a0573f5.pdf",//"./roomicon/111.pdf",//
    }
  },
  mounted() {

    // 普通pdf 打开方式
    this.pdfh5 = new Pdfh5("#demoH5", {
      pdfurl: this.pdfSrc
    });
    // base64 pdf 打开方式
    /*this.pdfh5 = new Pdfh5("#demoH5", {
      pdfurl: "data:application/pdf;base64,"+this.pdfSrc
    });*/
    //监听完成事件
    this.pdfh5.on("complete", function (status, msg, time) {
      console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
    })
  },
  methods: {

  }

}
</script>